import { render, staticRenderFns } from "./ExchangesView.vue?vue&type=template&id=19e100b0"
import script from "./ExchangesView.vue?vue&type=script&lang=ts"
export * from "./ExchangesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports